var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07524 0.82678C8.8705 0.724407 8.6295 0.724407 8.42476 0.82678L1.15218 4.46314C0.616153 4.73116 0.616153 5.49611 1.15218 5.76413L8.42476 9.40049C8.6295 9.50287 8.8705 9.50287 9.07524 9.40049L16.3478 5.76413C16.8838 5.49611 16.8838 4.73116 16.3478 4.46314L9.07524 0.82678ZM3.10362 5.11364L8.75 2.29039L14.3964 5.11364L8.75 7.93688L3.10362 5.11364ZM1.80266 11.7359C1.44341 11.5562 1.00656 11.7019 0.826938 12.0611C0.647313 12.4204 0.792928 12.8572 1.15218 13.0369L8.42476 16.6732C8.6295 16.7756 8.8705 16.7756 9.07524 16.6732L16.3478 13.0369C16.7071 12.8572 16.8527 12.4204 16.6731 12.0611C16.4934 11.7019 16.0566 11.5562 15.6973 11.7359L8.75 15.2096L1.80266 11.7359ZM0.826938 8.42475C1.00656 8.0655 1.44341 7.91988 1.80266 8.09951L8.75 11.5732L15.6973 8.09951C16.0566 7.91988 16.4934 8.0655 16.6731 8.42475C16.8527 8.78401 16.7071 9.22086 16.3478 9.40049L9.07524 13.0369C8.8705 13.1392 8.6295 13.1392 8.42476 13.0369L1.15218 9.40049C0.792928 9.22086 0.647313 8.78401 0.826938 8.42475Z",
    fill: "#AAAAAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_16",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07524 0.82678C8.8705 0.724407 8.6295 0.724407 8.42476 0.82678L1.15218 4.46314C0.616153 4.73116 0.616153 5.49611 1.15218 5.76413L8.42476 9.40049C8.6295 9.50287 8.8705 9.50287 9.07524 9.40049L16.3478 5.76413C16.8838 5.49611 16.8838 4.73116 16.3478 4.46314L9.07524 0.82678ZM3.10362 5.11364L8.75 2.29039L14.3964 5.11364L8.75 7.93688L3.10362 5.11364ZM1.80266 11.7359C1.44341 11.5562 1.00656 11.7019 0.826938 12.0611C0.647313 12.4204 0.792928 12.8572 1.15218 13.0369L8.42476 16.6732C8.6295 16.7756 8.8705 16.7756 9.07524 16.6732L16.3478 13.0369C16.7071 12.8572 16.8527 12.4204 16.6731 12.0611C16.4934 11.7019 16.0566 11.5562 15.6973 11.7359L8.75 15.2096L1.80266 11.7359ZM0.826938 8.42475C1.00656 8.0655 1.44341 7.91988 1.80266 8.09951L8.75 11.5732L15.6973 8.09951C16.0566 7.91988 16.4934 8.0655 16.6731 8.42475C16.8527 8.78401 16.7071 9.22086 16.3478 9.40049L9.07524 13.0369C8.8705 13.1392 8.6295 13.1392 8.42476 13.0369L1.15218 9.40049C0.792928 9.22086 0.647313 8.78401 0.826938 8.42475Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_16)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.76a1af00590166cd8b95e9b50b58d6d8.svg";
export { ForwardRef as ReactComponent };